import {Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text} from "@chakra-ui/react";
import AppDownloadBadges from "./AppDownloadBadges";

type Props = {
    isOpen: boolean,
    onClose: () => void
}

const InstallAppDialog = ({isOpen, onClose}: Props) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Install the listener app</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <Stack spacing={4}>
                        <Text fontSize={"sm"} color={"gray.600"}>
                            The SoundSpots listener app runs on the device that triggers audio
                            in the field. Install it on the phone or tablet you want to use.
                        </Text>
                        <AppDownloadBadges/>
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant={"outline"} onClick={onClose}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default InstallAppDialog;
